import { Box, Image, Loader, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../lib";

interface ReportIdentityLogoPreviewProps {
  logoS3Key: string | null;
  targetName: string;
}

export function ReportIdentityLogoPreview({
  logoS3Key,
  targetName,
}: ReportIdentityLogoPreviewProps) {
  const { data: logoUrl, isLoading } = useQuery({
    queryKey: ["report-identity-logo", logoS3Key],
    queryFn: async () => {
      const response = await api.post<{ url: string }>(
        "/documents/download-url",
        {
          key: logoS3Key,
        }
      );
      return response.url;
    },
    enabled: Boolean(logoS3Key),
    staleTime: 5 * 60 * 1000,
  });

  return (
    <Box
      w={160}
      h={88}
      p="xs"
      style={{
        border: "1px solid var(--mantine-color-gray-3)",
        borderRadius: "var(--mantine-radius-sm)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {isLoading ? (
        <Loader size="sm" />
      ) : logoUrl ? (
        <Image
          src={logoUrl}
          alt={`${targetName} report logo`}
          fit="contain"
          mah={72}
          maw={144}
        />
      ) : (
        <Text size="xs" c="dimmed" ta="center">
          {logoS3Key ? "Logo unavailable" : "No logo configured"}
        </Text>
      )}
    </Box>
  );
}
